/** Persisted analytics choice. Absent until the visitor picks Accept or Decline. */
export const CONSENT_STORAGE_KEY = 'fef-ga-consent';

export type ConsentChoice = 'accepted' | 'declined';

export function readConsentChoice(): ConsentChoice | null {
  try {
    const value = globalThis.localStorage?.getItem(CONSENT_STORAGE_KEY);
    return value === 'accepted' || value === 'declined' ? value : null;
  } catch {
    return null;
  }
}

export function storeConsentChoice(choice: ConsentChoice): void {
  try {
    globalThis.localStorage?.setItem(CONSENT_STORAGE_KEY, choice);
  } catch {
    // Private mode can throw. The in-memory choice still applies for this view.
  }
}
